// extracted by mini-css-extract-plugin
module.exports = {"link":"CommunityFilesSection_link__3oPnD","uploadInput":"CommunityFilesSection_uploadInput__1le2h","table":"CommunityFilesSection_table__1hkh6"};